import { Responses } from './types'
import request from '@/helper/superagent-protected'
import rethrowApiError from './rethrow-api-error'
import store from '@/store'
import transcoHyperProxiMock from './mocks/transco-hyper-proxi.mock'
import {
  ITranscoHyperProxiRequest,
  IPatchTranscoHyperProxiRequest,
  IDeleteTranscoHyperProxiRequest,
} from './types/requests/transco-hyper-proxi'
import config from '../../public/config.json'

export async function searchProducts(
  query: string,
): Promise<Responses.ITranscoHyperProxiResponse[]> {
  const apiUrl = store.getters.parameters('apiUrl')
  return request
    .get(`${apiUrl}/v0/transco/products/search`)
    .query({ q: query })
    .then((res: any) => res.body)
    .catch((error: any) => rethrowApiError(error))
}

export async function searchProviders(
  query: string,
): Promise<Responses.ITranscoHyperProxiResponse[]> {
  const apiUrl = store.getters.parameters('apiUrl')
  return request
    .get(`${apiUrl}/v0/transco/providers/search`)
    .query({ q: query })
    .then((res: any) => res.body)
    .catch((error: any) => rethrowApiError(error))
}

export async function getAll(
  mock: boolean = false,
): Promise<Responses.ITranscoHyperProxiResponse[]> {
  // if (mock) {
  //   return transcoHyperProxiMock
  // }
  const apiUrl = store.getters.parameters('apiUrl')

  return request
    .get(`${apiUrl}/v0/transco/providers`)
    .then((res: any) => res.body)
    .catch((error: any) => rethrowApiError(error))
}

export async function getAllTranscoHyperProxisProducts(
  mock: boolean = false,
): Promise<Responses.ITranscoHyperProxiResponse[]> {
  const apiUrl = store.getters.parameters('apiUrl')

  return request
    .get(`${apiUrl}/v0/transco/products`)
    .then((res: any) => res.body)
    .catch((error: any) => rethrowApiError(error))
}

export async function putTransco(
  transcoHyperProxi: ITranscoHyperProxiRequest,
): Promise<Responses.ITranscoHyperProxiResponse> {
  const apiUrl = store.getters.parameters('apiUrl')
  if (transcoHyperProxi.proxiHierarchyList) {
    transcoHyperProxi.proxiHierarchyList = transcoHyperProxi.proxiHierarchyList.map(
      (i: any) => ({
        ...i,
        hierarchyElementLevel: config.nomenclatureHierarchy,
      }),
    )
  }
  return request
    .put(`${apiUrl}/v0/transco/providers`)
    .send(transcoHyperProxi)
    .then((res: any) => res.body)
    .catch((error: any) => rethrowApiError(error))
}

export async function patchTransco(
  transcoHyperProxi: IPatchTranscoHyperProxiRequest,
): Promise<Responses.ITranscoHyperProxiResponse[]> {
  const apiUrl = store.getters.parameters('apiUrl')
  if (transcoHyperProxi.proxiHierarchyList) {
    transcoHyperProxi.proxiHierarchyList = transcoHyperProxi.proxiHierarchyList.map(
      (i: any) => ({
        ...i,
        hierarchyElementLevel: config.nomenclatureHierarchy,
      }),
    )
  }
  return request
    .patch(`${apiUrl}/v0/transco/providers`)
    .send(transcoHyperProxi)
    .then((res: any) => res.body)
    .catch((error: any) => rethrowApiError(error))
}

// tslint:disable-next-line: max-line-length
export async function deleteTransco(
  deleteRequest: IDeleteTranscoHyperProxiRequest,
): Promise<Responses.ITranscoHyperProxiResponse[]> {
  const apiUrl = store.getters.parameters('apiUrl')
  const { hyperCode, proxiCode } = deleteRequest
  return request
    .delete(
      `${apiUrl}/v0/transco/providers?hyperCode=${hyperCode}&proxiCode=${proxiCode}`,
    )
    .then((res: any) => res.body)
    .catch((error: any) => rethrowApiError(error))
}

export function exportTransco(): Promise<any> {
  const apiUrl = store.getters.parameters('apiUrl')

  return request
    .get(`${apiUrl}/v0/transco/providers/export`)
    .then((res: any) => {
      return res.body
    })
    .catch((error: any) => rethrowApiError(error))
}
